import React, { useCallback, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createNewProduct, updateProduct } from "../../../../action";
import { GlobalState } from "../../../../GlobalState";
import Loading from "../../../../util/Loading";
import { TabTitle } from "../../../../util/titleChanger";
import FileList from "../../../FileList";
import FileUpload from "../../../FileUpload/index";
import { ToastContainer, toast } from "react-toastify";
import { api } from "../../../../util/urlConfig";

export default function ProductForm() {
  const { productId } = useParams();
  TabTitle(productId > 0 ? "Update Product" : "Create Product");
  const state = useContext(GlobalState);
  const signInUser = JSON.parse(localStorage.getItem("user_data"));

  //Local state
  const [productDetail] = state.productAPI.productDetail;
  const [id, setId] = state.productAPI.id;
  const [allCategories] = state.categoryAPI.allCategories;
  const [callback, setCallback] = state.productAPI.callback;

  const [files, setFiles] = useState([]);
  const [btnName, setBtnName] = useState("Save");
  const [focused, setFocused] = useState(false);
  const [values, setValues] = useState([]);

  //For auto complete state
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [selectCategory, setSelectCategory] = useState("");
  const suggestions = allCategories.filter((role) => role.name.toString().toLowerCase().includes(selectCategory.toString().toLowerCase()));

  const handleSuggestionClick = (suggestion) => {
    setSelectCategory(suggestion.name);
    setShowSuggestions(false);
    setValues({
      ...values,
      categoryId: suggestion.id,
    });
  };

  const onChangeSelectCategory = (e) => {
    setSelectCategory(e.target.value);
  };

  const uploadHandler = (file) => {
    if (files.some((f) => f.name === file.name)) {
      toast.warn("This image has already been uploaded!");
    } else {
      setFiles([...files, file]);
    }
  };

  //Remove image files from file list component
  const removeHandler = (filename) => {
    setFiles(files.filter((file) => file.name !== filename));
  };

  //Focus input elements
  const handleFocus = (e) => {
    setFocused(true);
  };

  //Get value form input elements and assign into values states
  const onChangeValue = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  // ***Here is code for converting "Base64" to javascript "File Object".***

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const convertAsImage = (url) => {
    if (typeof url !== "string") {
      console.warn("Invalid image URL", url);
      return;
    }

    const toDataURL = (url) =>
      fetch(url)
        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );

    toDataURL(url).then((dataUrl) => {
      try {
        const parts = url.split("/");
        const filename = parts[parts.length - 1];
        const [nameImage, ext] = filename.split(".");

        const fileData = dataURLtoFile(dataUrl, `${nameImage}.${ext}`);
        setFiles([fileData]);
      } catch (error) {
        console.error("Error converting image URL to File:", error);
      }
    });
  };

  useEffect(() => {
    if (productId > 0 && productDetail) {
      setBtnName("Update");
      setId(productId);
      setValues({
        name: productDetail.name || "",
        unit_type: productDetail.unit_type || "",
        price: productDetail.price || "",
        description: productDetail.description || "",
        categoryId: productDetail.category ? productDetail.category.id : "1",
      });

      const categoryId = productDetail.category ? productDetail.category.id : "1";
      const selectedCategory = allCategories.find((category) => category.id === categoryId);
      if (selectedCategory) {
        setSelectCategory(selectedCategory.name);
      }

      const imgUrl = productDetail.upload_image ? api + "/" + productDetail.upload_image.image_url : {};
      if (imgUrl) {
        convertAsImage(imgUrl);
      }
    }
  }, [productId, productDetail, allCategories]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".input-box")) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const submitForm = (e) => {
    e.preventDefault();

    var form = new FormData();
    form.append("name", values.name);
    form.append("unit_type", values.unit_type);
    form.append("price", values.price);
    form.append("categoryId", values.categoryId);
    form.append("description", values.description);
    form.append("updatedBy", signInUser.id);
    form.append("uploaded_file", files[0]);

    if (productId > 0) {
      updateProduct(productId, form, (res) => {
        if (res.status === 200) {
          toast.success(res.data);
          setCallback(!callback);
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    } else {
      form.append("createdBy", signInUser.id);
      createNewProduct(form, (res) => {
        if (res.status === 200) {
          toast.success(res.data);
          setCallback(!callback);
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    }
  };

  return !productDetail ? (
    <div className="form-container">
      <div className="loading-page-container">
        <Loading />
      </div>
    </div>
  ) : (
    <div className="form-container">
      <header>Product Form</header>
      <form onSubmit={submitForm} className="form">
        <FileUpload uploadHandler={uploadHandler} />
        <FileList files={files} removeHandler={removeHandler} />

        <div className="input-box">
          <label htmlFor="categoryId">Category</label>
          <input
            type="text"
            name="categoryId"
            id="categoryId"
            placeholder="Enter Category Name"
            value={selectCategory}
            required
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeSelectCategory}
            onFocus={() => setShowSuggestions(true)}
          />
          {showSuggestions && (
            <ul className="suggestions">
              {suggestions.map((suggestion) => (
                <li key={suggestion.id} onClick={() => handleSuggestionClick(suggestion)}>
                  {suggestion.name}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="input-box">
          <label htmlFor="name">Product Name</label>
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Enter Product Name"
            value={values.name || ""}
            required
            pattern="^[A-Za-z0-9 ,]{3,}$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />

          <span>Product name should be above 3 characters and shouldn't any spacial character</span>
        </div>

        <div className="input-box">
          <label htmlFor="unit_type">Unit Type</label>
          <select className="select-box" name="unit_type" id="unit_type" value={values.unit_type} placeholder="Select a unit type" onChange={onChangeValue}>
            <option>Select a unit type</option>
            <option value="Kg">Kg</option>
            <option value="Bottle">Bottle</option>
            <option value="Litre">Litre</option>
            <option value="Unit">Unit</option>
          </select>
        </div>

        <div className="input-box">
          <label htmlFor="price">Price</label>
          <input
            type="text"
            name="price"
            id="price"
            placeholder="Enter Price"
            required
            pattern="^\d+(\.\d{1,2})?$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
            value={values.price || ""}
          />
          <span>Price should be number and more 1.</span>
        </div>

        <div className="input-box">
          <label htmlFor="description">Description</label>
          <textarea name="description" id="description" cols="30" rows="5" value={values.description || ""} onChange={onChangeValue} placeholder="Enter description here..."></textarea>
        </div>

        <div className="form-button">
          <button className="add_new">{btnName}</button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
}
